import React from 'react';
import SkeletonLoaderExample from './SkeletonLoaderExample';
import TestPage from './TestPage';

/**
 * SkeletonLoaderTest Component
 * 
 * A test page to demonstrate the SkeletonLoader component
 */
const SkeletonLoaderTest = () => {
  return (
    <TestPage
      title="Skeleton Loader Component"
      description="This page demonstrates the SkeletonLoader component with various configurations. The component shows flashing bars that can be used as placeholders during loading states."
    >
      <SkeletonLoaderExample />
    </TestPage>
  );
};

export default SkeletonLoaderTest;
